module.exports = __webpack_public_path__ + "static/media/titleH2.018344c3.png";